import React, { useEffect, useState } from 'react';
import { message } from 'antd';

export default function useGetFirstData(getDataFunc, formInfo, otherQuery = {}) {
  const [content, setContent] = useState({
    list: [],
    totalPage: '',
    totalCount: '',
    loading: '',
  });

  useEffect(() => {
    if (JSON.stringify(formInfo) !== '{}') return;
    getDataFunc({
      currentPage: 1,
      pageSize: 10,
      ...otherQuery,
    })
      .then((res) => {
        const {
          ret,
          data: { list = [], totalPage, totalCount },
        } = res;
        if (ret === '0') {
          setContent({
            list: list,
            loading: false,
            totalPage,
            totalCount,
          });
        } else {
          message.error(res.msg);
          setContent((content) => ({
            loading: false,
            ...content,
          }));
        }
      })
      .catch((ex) => {
        message.error(ex);
        setContent((content) => ({
          loading: false,
          ...content,
        }));
      });
    // eslint-disable-next-line
  }, [formInfo]);

  return content;
}
